import { createBrowserRouter } from 'react-router-dom';

import { STAFF_LOGIN_ROUTE } from './login/staff';
import { ADMIN_LOGIN_ROUTE } from './login/admin';
import { ACCOUNT_INFO_ROUTES } from './account-info';
import { CUSTOMER_DELIVERY_FILES_ROUTES } from './customer-delivery-files';
import { EXTERNAL_DELIVERY_FILES_ROUTES } from './external-delivery-files';
import { EMPLOYEE_MANAGEMENT_ROUTES } from './employee-management';
import { OPERATION_HISTORY_ROUTES } from './operation-history';
import { SYSTEM_ROUTES } from './system';
import { REGISTER_STAFF_ROUTE } from './register-staff';
import { FILE_DOWNLOAD_ROUTES } from './file-download';

export const AdminRoutes = createBrowserRouter(
  [
    { ...ADMIN_LOGIN_ROUTE },
    { ...ACCOUNT_INFO_ROUTES },
    { ...CUSTOMER_DELIVERY_FILES_ROUTES },
    { ...EXTERNAL_DELIVERY_FILES_ROUTES },
    { ...EMPLOYEE_MANAGEMENT_ROUTES },
    { ...OPERATION_HISTORY_ROUTES },
    { ...SYSTEM_ROUTES },
    { ...FILE_DOWNLOAD_ROUTES },
  ],
  { basename: '/' },
);

export const StaffRoutes = createBrowserRouter(
  [
    { ...STAFF_LOGIN_ROUTE },
    { ...REGISTER_STAFF_ROUTE },
    { ...ACCOUNT_INFO_ROUTES },
    { ...CUSTOMER_DELIVERY_FILES_ROUTES },
    { ...FILE_DOWNLOAD_ROUTES },
  ],
  { basename: '/' },
);

export const UserRoutes = createBrowserRouter([{ ...FILE_DOWNLOAD_ROUTES }], {
  basename: '/',
});
